import { GET_BARGAINS } from "../actions";
import { GET_BARGAIN_COUNT } from "../actions";

const defaultState = {
    bargainsLoading: true,
    bargains: [],
    bargainCount: ""
}

const bargainReducer = (state = defaultState, action) => {
    switch (action.type) {
        case GET_BARGAINS:
            return {
                ...state,
                bargainsLoading: action.payload.bargainsLoading,
                bargains: action.payload.bargains
            }
        case GET_BARGAIN_COUNT:
            return {
                ...state,
                bargainCount: action.payload.bargainCount
            }
        default: return state
    }
}

export default bargainReducer;